import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AuthorisationRoutingModule } from './authorisation-routing.module';
import { AuthorisationComponent } from './authorisation.component';
import { IdleWarningModalComponent } from './components/idle-warning-modal/idle-warning-modal.component';



@NgModule({
  declarations: [
    AuthorisationComponent,
    IdleWarningModalComponent
  ],
  imports: [
    CommonModule,
    AuthorisationRoutingModule
  ]
})
export class AuthorisationModule { }
